<template>
  <div class="home">
    <div
      class="burger"
      @click="navbar"
      v-bind:class="{ activeburger: isActive }"
    >
      <i class="fas fa-hand-rock fa-2x"></i>
    </div>
    <section class="navbar"  v-bind:class="{ activenav: isActive }">
      <nav>
        <ul>
          <li><a href="#1">Game Theory</a></li>
          <li><a href="#2">Stats </a></li>
          <li><a href="#3">Liquidity Staking</a></li>
          <li><a href="#5">Social Media</a></li>
        </ul>
      </nav>
    </section>

    <section class="first-section">
      <div>
        <firstsection id=""  />
      </div>

      <div class="uniswapLink">
      <span> <a href="#4">Are you a Strong Hand?</a> </span>
      </div>
    </section>

    <div class="divider"></div>

    <section>
      <gametheory id="1" class="second-section" />
    </section>

    <div class="divider"></div>

    <section>
      <stats id="2" class="third-section" />
    </section>

    <div class="divider"></div>

    <section>
      <liquiditystaking id="3" class="fourth-section" />
    </section>

    <div class="divider"></div>

    <section>
      <whales id="4" class="fourth-section" />
    </section>

    <div class="divider"></div>

    <section>
      <footersection id="5" class="last-section" />
    </section>
  </div>
</template>

<script>
import firstsection from "../components/FirstSection";
import gametheory from "../components/GameTheory";
import footersection from "../components/FooterSection";
import liquiditystaking from "../components/LiquidityStaking";
import stats from "../components/StatsSection";
import whales from '../components/WhaleSection'

export default {
  name: "Home",
  data() {
    return {
      isActive: false,
    };
  },
  components: {
    firstsection,
    gametheory,
    footersection,
    liquiditystaking,
    stats,
    whales
  },
  methods: {
    navbar() {
      this.isActive = !this.isActive;
    },
  },
};
</script>

<style lang="scss" scoped>

.home {
  background: black;
}

.divider {
  border-bottom: 1px solid rgb(150, 150, 150);
  width: 80%;
  margin: auto;
}

.first-section {
  position: relative;
  width: 80%;
  margin: auto;

  .uniswapLink {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 1em;

    a {
      color: rgb(150, 150, 150);
      text-decoration: none;
    }
  }
}

.second-section {
  width: 50%;
  margin: auto;
}

.third-section {
   width: 50%;
  margin: auto;
}

.fourth-section {
   width: 50%;
  margin: auto;
}
.burger {
  display: none;
}
.navbar {
  font-family: "Turret Road", cursive;
  background: black;
  font-weight: 900;
  letter-spacing: 0.15em;
  font-size: 1.1em;
  padding: 1.5em;
  transition: all 0.2s ease-in-out;
  animation-name: navbarAni;
  -webkit-animation-name: navbarAni;
  -moz-animation-name: navbarAni;
  animation-duration: 3s;
  -webkit-animation-duration: 3s;
  -moz-animation-duration: 3s;

  ul {
    display: flex;
    justify-content: space-around;
    width: 60%;
    margin-left: auto;

    li {
      list-style: none;

      a {
        color: white;
        text-decoration: none;
      }
    }
  }
}

@keyframes navbarAni {
  0% {opacity: 0;};
  100% {opacity: 1;}
}

@media (max-width: 1500px) {
  
  .second-section {
  width: 80%;
}

.third-section {
  width: 80%;
}

.fourth-section {
   width: 80%;
}

  .navbar {
    ul {
      width: 80%;
    }
  }
}

@media (max-width: 900px) {

  .divider {
    width: 100%;
  }

  .first-section {
    width: 100%;
  }
  
  .second-section {
  width: 90%;
}

.third-section {
  width: 90%;
}

.fourth-section {
   width: 90%;
}

  .navbar {
    ul {
      width: 100%;
    }
  }
}

@media (max-width: 800px) {
  .navbar {
    ul {
      font-size: 75%;
    }
  }
}

@media (max-width: 600px) {
  .home {
    position: relative;

  }

  .second-section {
  width: 100%;
}

.third-section {
  width: 100%;
}

.fourth-section {
   width: 100%;
}

  .burger {
    color: white;
    position: fixed;
    top: 1em;
    right: 1.5em;
    cursor: pointer;
    z-index: 2;
    display: block;
  }

  .activeburger {
    color: black;
    transition: all 0.2s ease-in-out;
  }

  .navbar {
    position: fixed;
    width: 100%;
    background: white;
    left: -100%;
    z-index: 1;

    ul {
      display: grid;
      grid-gap: 2em;
      justify-content: center;

      li a {
        color: black;
        font-weight: bold;
      }
    }
  }

  .activenav {
    top: 0;
    left: 0;
  }
}
</style>